module.exports = __webpack_public_path__ + "img/icon-paper.36eaf87e.png";